<template>
    <section class="contact-section position-relative">
        <div class="bg-company-img set-height100">
            <div class="container set-absolute">
                <div class="row justify-content-center">
                    <div class="col-md-8 form-info">
                        <p>
                          {{ $t('formation.contact.text_1') }}<br />
                          {{ $t('formation.contact.text_2') }}
                        </p>
                    </div>
                    <div class="col-md-8 form-content">
                        <form >
                            <div class="mb-3">
                                <input-text :label="$t('formation.contact.form.name')"  :customInput="false" />
                            </div>

                            <div class="mb-3">
                                <input-text :label="$t('formation.contact.form.firstName')"  :customInput="false" />
                            </div>

                            <div class="mb-3">
                                <input-text :label="$t('formation.contact.form.email')"  :customInput="false" :type="'email'" />
                            </div>

                            <div class="mb-3">
                                <input-text-area :label="$t('formation.contact.form.message')" :rows="6" />
                            </div>
                            <p class="text-center"><a href="#" class="btn">{{ $t('formation.contact.send') }}</a></p>
                        </form>
                    </div>
                </div>
            </div>

        </div>
    </section>

</template>
<script>
import text from '@/components/frontoffice/form/baseInput/text'
import textArea from '@/components/frontoffice/form/baseInput/textAreaBVue'

export default {
  components: {
    'input-text': text,
    'input-text-area': textArea
  }
}
</script>

<style scoped lang="scss">
.form-info{
    font-size: 1.1rem;
    font-weight: bold;
    padding-top: 2rem;
}

.form-info, .form-content{
    color: #1A2050;
}
.btn{
    background-color: #E65011;
    color: white;
}
.btn:hover{
    color: #212529;
}
.bg-company-img{
    background-image: url('~@/assets/img/bba/loginBba2.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}
form{
    padding-top: 3rem;
}
@media (min-width: 576px) {
    .container{
        max-width: 540px;
    }
}
@media (min-width: 768px) {
    .container{
        max-width: 720px;
    }
}
@media (min-width: 992px) {
    .set-height100 {
        height: 100vh;
    }
    .contact-section .set-absolute{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .container{
        max-width: 960px;
    }
}
@media (min-width: 1200) {
    .container{
        max-width: 1140;
    }
}
@media (min-width: 1400px) {
    .container{
        max-width: 1320px;
    }
}
</style>
